import fetch from 'isomorphic-fetch';
import P from '../../pages';
import React from 'react';
import ReactGA from "react-ga";
import { get } from 'lodash'
import HCaptcha from '@hcaptcha/react-hcaptcha';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import Button from 'react-bootstrap/lib/Button';
import Alert from './Alert'
import { defaultMessages } from '../../../../libs/i18n/default';
import ReactOnRails from 'react-on-rails';
import FormDate from './FormDate';
import GoogleMapsAddress from './GoogleMapsAddress';
import ReactMarkdown from 'react-markdown';
import GenerateDetailsButton from './GenerateDetailsButton';
import ProfileElementField from './ProfileElementField';
import CustomFormGroup from './CustomFormGroup';
import PhoneVerification from '../../../../shared/components/PhoneVerification';
import { CriticalContract } from '../../../../shared/components';
import { validator, fieldsToValidate, pageValid, executeValidations } from '../../validator';
import { setElementValue, randomChars } from '../../../../shared/utilities';
import { setSelectElementValue, changeState } from '../../utilities';

class RegisterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      address: props.address || {},
      placeId: {
        val: get(props.address, 'place_id', ''),
        validationKey: this.existingPlace() ? '' : 'attributes_place_id',
        showPopover: false,
      },
      email: {val: '', validationKey: 'attributes_user_email', showPopover: false},
      dob: {val: '', validationKey: 'attributes_user_dob', showPopover: false},
      givenNames: {val: '', validationKey: 'attributes_user_given_names'},
      familyName: {val: '', validationKey: 'attributes_user_family_name'},
      gender: {val: '', validationKey: this.props.showGenderField ? 'attributes_gender' : ''},
      maritalStatus: {val: '', validationKey: 'profile_elements_lifestyle_marital_status'},
      referredFrom: {val: '', validationKey: 'attributes_referred_from'},
      password: {val: '', validationKey: 'attributes_user_password', showPopover: false},
      phone: {val: '', validationKey: 'attributes_phone'},
      phoneNumberVerified: false,
      loading: false,
      acceptedContracts: [],
      passedRecaptcha: this.props.recaptchaSiteId ? false : true,
      captchaBlocked: this.props.recaptchaSiteId ? null : false
    };
    this.submit = this.submit.bind(this);
    this.goBack = this.goBack.bind(this);
    this.selectOptions = this.selectOptions.bind(this);
    this.generateRandomHostDetails = this.generateRandomHostDetails.bind(this);
    this.changeState = this.changeState.bind(this);
    this.updateAddressState = this.updateAddressState.bind(this);
    this.updateDobState = this.updateDobState.bind(this);
    this.validateAddress = this.validateAddress.bind(this);
    this.recaptchaCallback = this.recaptchaCallback.bind(this);
  }

  changeState = async(id, val) => {
    let obj = this.state[id]

    if ('showPopover' in obj) { obj.showPopover = false }
    this.setState({[id]: obj});

    changeState(this, id, val)
  }

  existingPlace(){
    return get(this.props.address, 'place_id', null)
  }

  validateAddress = async validations => { 
    if (this.props.territory_code !== 'SRSC') return

    let obj = this.state['placeId']
    let valid = await validator(validations, obj.validationKey, this.props.requiredFields)

    obj.valid = valid

    this.setState({ placeId: obj });
  }

  updateAddressState(key, value) {
    if (key == 'place_id') {
      this.changeState('placeId', value)
    }

    let addressState = this.state.address || {};
    addressState[key] = value;

    if (addressState.state && addressState.post_code) {
      const addressValidations = {
        state: addressState.state,
        postcode: addressState.post_code
      }

      this.validateAddress(addressValidations)
    }

    this.setState({ address: addressState });
  }

  updateDobState = async (value) => {
    let dobState = { ...this.state.dob }

    dobState.val = value
    dobState.valid = await validator(value, dobState.validationKey, this.props.requiredFields)

    if ('showPopover' in dobState) {
      dobState.showPopover = !dobState.valid
    }

    this.setState({ dob: dobState })
  }

  linkRenderer(props) {
    return <a href={props.href} target="_blank">{props.children}</a>
  }

  genderField(){
    const { formatMessage } = this.props.intl;
    return(
      this.props.showGenderField
      ? <CustomFormGroup valid={this.state.gender.valid} >
          <ControlLabel>{formatMessage(defaultMessages.clientHostPagesRegisterPlaceholdersGender)}</ControlLabel>
          <FormControl id="gender"
            componentClass="select"
            onChange={e => this.changeState(e.target.id, e.target.value)} >
            <option value="" key="no_option">{formatMessage(defaultMessages.clientHostPagesRegisterPlaceholdersReferral)}</option>
            <option value='Male' key='Male'>{formatMessage(defaultMessages.clientCommonMale)}</option>
            <option value='Female' key='Female'>{formatMessage(defaultMessages.clientCommonFemale)}</option>
            <option value='Other' key='Other'>{formatMessage(defaultMessages.clientCommonOtherGender)}</option>
          </FormControl>
        </CustomFormGroup>
      : null
    )
  }

  selectOptions(options){
    const { formatMessage } = this.props.intl;
    if (typeof options !== 'undefined' && options.length > 0){
      const mo = [<option value="" key="no_option">{formatMessage(defaultMessages.clientHostPagesRegisterPlaceholdersReferral)}</option>];
      options.forEach(function(f){
        mo.push(<option value={f} key={f}>{f}</option>);
      });
      return mo;
    }
  }

  updateAcceptedContracts(contract, accepted){
    let newAcceptedContracts = this.state.acceptedContracts.slice(0)
    if (accepted){
      if(!newAcceptedContracts.includes(contract.id)){
        newAcceptedContracts.push(contract.id)
      }
    } else {
      newAcceptedContracts = newAcceptedContracts.filter(ac => ac != contract.id)
    }
    this.setState({acceptedContracts: newAcceptedContracts})
  }

  allContractsSigned(){
    return this.props.criticalContracts.filter(c => !this.state.acceptedContracts.includes(c.id)).length == 0
  }

  submit() {
    const phoneInputValue = document.getElementById('phone')?.value;
    const phone = this.state.phone.val || phoneInputValue || '';

    if (!this.state.phone.val && phoneInputValue) {
      console.warn('[host-signup] Register phone state was blank on submit; using visible input value.');
    }

    const emailInputValue = document.getElementById('email')?.value;
    const stateEmail = this.state.email?.val || '';
    const email = (emailInputValue && emailInputValue.length >= stateEmail.length)
      ? emailInputValue
      : (stateEmail || emailInputValue || '');

    if (!stateEmail && emailInputValue) {
      console.warn('[host-signup] Register email state was blank on submit; using visible input value.');
    } else if (emailInputValue && stateEmail && emailInputValue !== stateEmail) {
      console.warn(`[host-signup] Register email state (${stateEmail}) differed from visible input (${emailInputValue}); using input value.`);
    }

    this.setState({loading: true});
    this.props.onRegisterUser({
      csrf_token: ReactOnRails.authenticityToken(),
      givenNames: this.state.givenNames.val,
      familyName: this.state.familyName.val,
      phone,
      email,
      password: this.state.password.val,
      dob: this.state.dob.val,
      gender: this.state.gender.val,
      referredFrom: this.state.referredFrom.val,
      maritalStatus: this.state.maritalStatus.val,
      sign_up_method: 'wizard_v1',
      address: this.state.address
    });
    ReactGA.event({
      category: 'HMS Lobby',
      action: 'Sign Up',
      label: 'Host Wizard'
    });
  }

  goBack(){
    let params = new URLSearchParams(window.location.search)
    params.delete('place_id')
    window.history.replaceState({}, document.title, `/hosts/signup${params.toString() ? `?${params.toString()}` : ''}#/register`)
    this.props.onGoBack()
  }

  recaptchaCallback() {
    this.setState({ passedRecaptcha: true })
  }

  checkCaptcha() {
    fetch('https://newassets.hcaptcha.com/captcha/v1/c3d9cf0/hcaptcha.js', {
      method: 'GET',
    })
    .then(() => this.setState({ captchaBlocked: false }))
    .catch(() => this.setState({ captchaBlocked: true }))
  }

  renderRequiredControlLabel = (defaultMessage) => {
    const { formatMessage } = this.props.intl;
    return (
      <ControlLabel>
        {formatMessage(defaultMessage)}<span style={{ color: 'red', fontSize: '15px' }}>*</span>
      </ControlLabel>
    );
  };

  componentDidMount() {
    if (this.props.recaptchaSiteId && this.state.captchaBlocked === null) {
      this.checkCaptcha()
    }
  }

  render() {
    const thisPage = P.REGISTER_PAGE;
    const { formatMessage } = this.props.intl;

    return(
      <div className="register_form">
        <GenerateDetailsButton
          generateDetails={this.generateRandomHostDetails}
          enabled={this.props.generateDetailsEnabled}
          text='Generate'
          environment={this.props.environment}/>

        <CustomFormGroup valid={this.state.givenNames.valid}>
          {this.renderRequiredControlLabel(defaultMessages.clientHostPagesRegisterPlaceholdersFirstName)}
          <FormControl id="givenNames"
            type="text"
            componentClass="input"
            onChange={e => this.changeState(e.target.id, e.target.value)} />
        </CustomFormGroup>

        <CustomFormGroup valid={this.state.familyName.valid}>
          {this.renderRequiredControlLabel(defaultMessages.clientHostPagesRegisterPlaceholdersLastName)}
          <FormControl id="familyName"
            type="text"
            componentClass="input"
            onChange={e => this.changeState(e.target.id, e.target.value)} />
        </CustomFormGroup>

        <PhoneVerification>
          {this.renderRequiredControlLabel(defaultMessages.clientHostPagesRegisterPlaceholdersPhone)}
          <PhoneVerification.RegisterInput
            validations={this.state.phone.valid}
            onChange={e => this.changeState(e.target.id, e.target.value)}
            Wrapper={CustomFormGroup}
            countryCode={this.props.country_code}
          />
          
        </PhoneVerification>

        <CustomFormGroup
          valid={this.state.email.valid}
          validationMessage={formatMessage(defaultMessages.clientHostPagesRegisterPopoversEmailContent)}
          showPopover={this.state.email.showPopover}
          tooltipPosition='left' >
          {this.renderRequiredControlLabel(defaultMessages.clientHostPagesRegisterPlaceholdersEmail)}
          <FormControl id="email"
            type="email"
            componentClass="input"
            onChange={e => this.changeState(e.target.id, e.target.value)} />
        </CustomFormGroup>

        <CustomFormGroup
          valid={this.state.password.valid}
          validationMessage={formatMessage(defaultMessages.clientHostPagesRegisterPopoversPasswordContent)}
          showPopover={this.state.password.showPopover}
          tooltipPosition='right' >
          {this.renderRequiredControlLabel(defaultMessages.clientHostPagesRegisterPlaceholdersPassword)}
          <FormControl id="password"
            placeholder={formatMessage(defaultMessages.clientHostPagesRegisterPlaceholdersPassword)}
            type="password"
            componentClass="input"
            onChange={e => this.changeState(e.target.id, e.target.value)} />
        </CustomFormGroup>

        {
          this.existingPlace()
          ? <div>
              <FormGroup className={'form-group has-feedback has-success'}>
                <span className={'form-control-feedback'}>
                  <i className={'fa fa-check-circle fa-2x'}></i>
                </span>
                <ControlLabel>Address</ControlLabel>
                <FormControl
                  type="text"
                  componentClass="input"
                  className='div-disabled'
                  id='existing-address'
                  readOnly
                  value={this.state.address.searchedAddress || this.state.address.formatted_address} />
                <div className="text-muted small">
                  Go back to change your address
                </div>
              </FormGroup>
            </div>
          : <CustomFormGroup
            valid={this.state.placeId.valid}
            showPopover={this.state.placeId.showPopover}
            validationMessage={`Please search for your address and select it from the results that load. If your address is not found, please contact <a href='mailto:${this.props.transaction_email}'>${this.props.transaction_email}</a>`}
            tooltipPosition='left' >
            {this.renderRequiredControlLabel(defaultMessages.clientHostPagesRegisterLabelsAddress)}
            <GoogleMapsAddress
              addressValidations={this.props.addressValidations}
              updateAddress={this.updateAddressState}
              countryCode={this.props.country_code}
              formatMessage={formatMessage}
              territory_code={this.props.territory_code}
            />
          </CustomFormGroup>
        }

        <CustomFormGroup
          valid={this.state.dob.valid}
          showPopover={this.state.dob.showPopover}
          validationMessage={formatMessage(defaultMessages.clientHostPagesRegisterPopoversTooYoungContent)}
          tooltipPosition='right'
          id='formgroup-dob'>
          {this.renderRequiredControlLabel(defaultMessages.clientHostPagesRegisterLabelsDob)}
          <FormDate updateDateState={this.updateDobState} intl={this.props.intl} />
          <div className='error-message' style={{color: '#b77600'}}>
            {formatMessage(defaultMessages.clientHostPagesRegisterPopoversAgeLimitContent)}
          </div>
        </CustomFormGroup>

        {this.genderField()}

        <ProfileElementField
          childComponent={
            <CustomFormGroup valid={this.state.maritalStatus.valid}>
              {this.renderRequiredControlLabel(defaultMessages.clientHostPagesRegisterLabelsMaritalStatus)}
              <FormControl id="maritalStatus"
                componentClass="select"
                placeholder="select"
                onChange={e => this.changeState(e.target.id, e.target.value)} >
                {this.selectOptions(this.props.marital_statuses || undefined)}
              </FormControl>
            </CustomFormGroup>
          }
          elementName='marital_status' />

        <CustomFormGroup valid={this.state.referredFrom.valid}
          extraClass={'with-label'}>
          {this.renderRequiredControlLabel(defaultMessages.clientHostPagesRegisterLabelsReferredFrom)}
          <FormControl id="referredFrom"
            componentClass="select"
            placeholder="select"
            onChange={e => this.changeState(e.target.id, e.target.value)} >
            {this.selectOptions(this.props.marketing_referrers.sort())}
          </FormControl>
        </CustomFormGroup>

        <div className="text-center">
          <div style={{ marginBottom: 10 }}>
            {this.props.criticalContracts.map((c, i) => (
              <CriticalContract
                contract={c}
                key={`contract_${i}`}
                contractAccepted={(accepted) => this.updateAcceptedContracts(c, accepted)}/>
            ))}
          </div>


          {this.props.recaptchaSiteId && (
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
              <HCaptcha
                sitekey={this.props.recaptchaSiteId}
                onVerify={(token,ekey) => { this.recaptchaCallback() }}
              />
            </div>
          )}

          {this.state.captchaBlocked === true && (
            <div className="alert alert-danger">
              <p>Failed to load recaptcha. Your privacy settings may be too high. Please adjust your browser security and try again.</p>
            </div>
          )}

          {
            this.existingPlace() &&
            <Button
              type="submit"
              id='back_btn'
              style={{float: 'left'}}
              onClick={this.goBack}
              className="btn btn-warning btn-lg">Back</Button>
          }
          <Button
            type="submit"
            id='sign_up_btn'
            onClick={this.submit}
            style={{float: this.existingPlace() && 'right'}}
            disabled={!this.allContractsSigned() || !pageValid(this.state, this.props.requiredFields) || this.state.loading || !this.state.passedRecaptcha}
            className="btn btn-primary btn-lg">{formatMessage(defaultMessages.clientHostPagesRegisterButtonsSignup)}
          </Button>
          {!(this.allContractsSigned() && pageValid(this.state, this.props.requiredFields)) && (
            <p style={{ marginTop: 3, color: 'red' }}>{formatMessage(defaultMessages.clientHostPagesRegisterLabelsCompleteFields)}</p> 
          )}
        </div>
      </div>
    );
  }

  generateRandomHostDetails(){
    let randomID = randomChars(4);
    let schoolName = this.props.territory_code == 'AUS' ? 'Toowong Village' : '5400 Kirkside Dr Bakersfield CA'
    setElementValue(document.getElementById('givenNames'), 'Test')
    .then(() => setElementValue(document.getElementById('familyName'), `host ${randomID}`))
    .then(() => setElementValue(document.getElementById('phone'), `0400111222`))
    .then(() => setElementValue(document.getElementById('weChatId'), `guest${randomID}`))
    .then(() => setElementValue(document.getElementById('email'), `test_host_${randomID}@random.com`, 'input'))
    .then(() => setElementValue(document.getElementById('password'), 'Password123'))
    .then(() => setElementValue(document.getElementById('gender'), 'Male', 'change'))
    .then(() => setElementValue(document.getElementById('date_month'), '01', 'change'))
    .then(() => setElementValue(document.getElementById('date_day'), '01'))
    .then(() => setElementValue(document.getElementById('date_year'), '2000'))
    .then(() => setElementValue(document.getElementById('referredFrom'), 'Other', 'change'))
    .then(() => setElementValue(document.getElementById('maritalStatus'), 'Married', 'change'))
  }
}
export default RegisterForm;
